import React from 'react';
import ProductPage from './ProductPage';

export default function PPCShield() {
  return (
    <ProductPage
      badge="⛉ PPC Shield"
      title="Stop paying for"
      titleAccent="fraudulent ad clicks"
      subtitle="Real-time click-fraud detection and automatic IP exclusion for Google Ads, Meta Ads, and Microsoft Ads. Fraud blocked before your budget sees it."
      features={[
        { icon: '◉', title: 'Click-level verdict in <1s', body: '2,000+ behavioural and technical tests run in parallel on every paid click.' },
        { icon: '🚫', title: 'Auto IP exclusion', body: 'Fraud IPs are pushed to your Google Ads exclusion list the moment they are detected — no manual list management.' },
        { icon: '🎯', title: 'Audience exclusion sync', body: 'Flagged visitors are added to custom exclusion audiences on Meta and Microsoft so remarketing stays clean.' },
        { icon: '◱', title: 'Per-campaign breakdown', body: 'See invalid rate and wasted spend per campaign, device, and country.' },
        { icon: '⚙', title: 'Threshold &amp; VPN rules', body: 'Block repeat clickers, VPNs, Tor, datacentres, and off-geo traffic with per-campaign rules.' },
        { icon: '📅', title: 'Scheduled sync', body: 'IP exclusions refresh hourly, daily, or on your schedule. Zero touch after setup.' },
        { icon: '🚨', title: 'Instant spike alerts', body: 'Get an email or Slack ping the moment any campaign\'s fraud rate crosses your threshold.' },
      ]}
      stats={[
        { value: '$84B', label: 'lost to click fraud yearly' },
        { value: '22%', label: 'of ad spend wasted on average' },
        { value: '<1s', label: 'detection latency' },
        { value: '15–25%', label: 'typical ClickSaver savings' },
      ]}
      ctaTitle="Reclaim the budget bots are stealing"
      ctaBody="Install in under 5 minutes. See fraud blocked within the first hour."
    />
  );
}
